export enum UserActionType {
  FETCH_USERS = "FETCH_USERS",
  SET_USER = "SET_USER",
  SET_USER_LOGIN = "SET_USER_LOGIN",
  UPDATE_USER = "UPDATE_USER",
  SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED",
  SET_AUTHENTICATED = "SET_AUTHENTICATED",
  LOADING_USER = "LOADING_USER",
}
